import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
import { VentaComponent } from './pages/venta/venta.component';
import { LibroVentasComponent } from './recepcion/components/libro-ventas/libro-ventas.component';


const routes: Routes = [
  {path: 'home/:id', component: HomeComponent},
  {path: 'login', component: LoginComponent},
  {path: 'venta', component: VentaComponent, children: [
    {
      path: 'opciones',
      loadChildren: () => import('./opciones/opciones.module').then(m => m.OpcionesModule)
    },
    { path: '', redirectTo: 'opciones', pathMatch: 'full'}
  ]},
  {
    path: 'recepcion',
    loadChildren: () => import('./recepcion/recepcion.module').then((m) => m.RecepcionModule)
  },
  {path: '', pathMatch: 'full', redirectTo: 'login'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
